module.exports = __webpack_public_path__ + "static/media/phoneButton.03c750e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/phoneButton.svg
// module id = 177
// module chunks = 0